var SVGMask = {};

function createSVG( i, img, overlay, color, variant ) {
	//console.log(i);
	if ( overlay ) {
		var viewbox = '0 0 1300 1300',
			x = 0,
			y = 0;
		return `<svg x="0" y="0" viewBox="${viewbox}">
				<filter id="imageMultiply_${i}">
					<feImage xlink:href="#photo_${i}" x="${x}px" y="${y}px" width="100%" height="100%"/>
					<feBlend in2="SourceGraphic" mode="multiply"/>
				</filter>

				<g id="photo_${i}" mask="url(#myMask_${i})">
					<image x="0" y="300px" href="${img}" height="800px" width="800px"/>
				</g>
				<mask id="myMask_${i}">
					<rect x="0" y="0" width="100%" height="100%" fill="black" />
					<path d="M1296.01021,238.110838 C1250.71421,175.748596 1209.66265,149.641506 1146.95596,109.894143 C1084.21163,70.1937183 1014.48421,41.5050215 941.152306,23.3868328 C721.090713,-30.9114074 468.22175,10.3285942 272.450409,136.808572 C207.212117,178.968564 152.279067,219.476328 99.1153179,279.332065 C-133.43491,541.322951 74.0157041,952.652774 402.814057,1000.03231 C460.288126,1009.34487 527.229841,1010.72485 592.44931,995.441739 C932.136397,903.245506 1179.3963,652.69818 1310.88929,333.545816 C1319.18995,302.566529 1315.25607,270.939494 1296.01021,238.110838" fill="white"></path>
				</mask>
		</svg>`;
	} else {
		return `<svg x="0px" y="0px" viewBox="0 0 800 800">
			<mask id="myMaskOverlay">
				<rect x="0" y="0" width="100%" height="100%" fill="black" />
				<path d="M447.806324,795.381651 C828.673231,734.980174 919.83882,331.976555 626.436464,89.3092162 C230.065206,-238.452909 -231.484347,419.054015 131.717601,722.503344 C155.504277,742.350116 185.072577,758.331674 217.621713,770.488072 C291.322401,798.065271 379.667198,806.196239 447.806324,795.381651 Z" fill="white"></path>
			</mask>
			<g mask="url(#myMaskOverlay)">
				<image href="${img}" height="100%" width="100%"/>
			</g>
		</svg>`;
	}
}

SVGMask.init = function() {
	let i = 1;
	$( '.svg-image' ).each( function() {
		var $this = $(this);
		var colorOverlay = ( $this.parents( '.hero').length > 0 ) ? true : false,
			color = ( $this.parents( '.hero').length > 0 ) ? $this.data('color') : false,
			variant = ( $this.parents( '.hero').length > 0 ) ? $this.data('variant') : false;
		var svg = createSVG( i, $this.data('src'), colorOverlay, color, variant );
		//console.log(i, svg);
		$this.append( svg ).addClass( 'is-shown' );
		i++;
	} );
}

export { SVGMask };
